<template lang="pug">
  v-menu(
    ref="timer"
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px")
    template(v-slot:activator="{ on }")
      ValidationProvider(:rules="rules" v-slot="{ errors }")
        v-text-field(
          v-model="time"
          readonly
          :disabled="disabled"
          v-on="on"
          :error="errors.length > 0")
          template(v-slot:label)
            v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
            v-icon.pr-1(:color="getColorError(errors.length)" size="22") mdi-clock-outline
            | {{ label }}
        span.red--text.text--accent-2(v-if="errors.length > 0")
          v-icon(color="red accent-2") mdi-alert
          |  {{ errors[0] }}
    v-time-picker(
      v-if="menu"
      v-model="time"
      full-width
      @click:minute="timeSelected()")
</template>

<script>
  export default {
    name: "BaseTimePicker",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    },
    data:() => ({
      menu: false,
      time: null,
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      }
    },
    watch: {
      value: function(val){
        this.time = val;
      }
    },
    created(){
      this.time = this.value;
    },
    methods:{
      getColorError(error){
        return error > 0 ? 'red accent-2' : '';
      },
      timeSelected(){
        this.$refs.timer.save(this.time);
        this.$emit('input', this.time);
      },
    },
  }
</script>

<style lang="sass">
</style>